






















import { MetaInfo } from 'vue-meta'
import { Component, Mixins } from 'vue-property-decorator'

// Types
import { IMasterDepositoryView } from '@/store/types'
// Components
import DepositoryViewToggle from '@/components/views/depository/DepositoryViewToggle.vue'
import KnowledgeBaseFolderCard from '@/components/cards/KnowledgeBaseFolderCard.vue'
import KnowledgeBaseMediaCard from '@/components/cards/KnowledgeBaseMediaCard.vue'
import KnowledgeBaseFolderRow from '@/components/rows/KnowledgeBaseFolderRow.vue'
import KnowledgeBaseFolderTable from '@/components/tables/KnowledgeBaseFolderTable.vue'
import Attachment from '@/components/_uikit/Attachment.vue'
// Mixins
import NotifyMixin from '@/mixins/NotifyMixin'
import PermissionsMixin from '@/mixins/PermissionsMixin'
// Store
import MasterDepositoryModule from '@/store/modules/master/depository'

@Component({
  components: {
    DepositoryViewToggle,
    KnowledgeBaseFolderCard,
    KnowledgeBaseMediaCard,
    KnowledgeBaseFolderRow,
    KnowledgeBaseFolderTable,
    Attachment,
  },
})
export default class DepositoryMonthFoldersView extends Mixins(NotifyMixin, PermissionsMixin) {
  private get view() {
    return MasterDepositoryModule.depositoryView
  }

  private get monthID () {
    return +this.$route.params.monthID
  }

  private get courseID () {
    return +this.$route.params.courseID
  }

  private get course () {
    return MasterDepositoryModule.courses.data.find(course => course.id === this.courseID)
  }

  private get title() {
    return MasterDepositoryModule.trainingFilesMonth.folders.find(folder => folder.id === this.monthID)?.title
  }

  private get folders() {
    return MasterDepositoryModule.trainingFilesTree
  }

  private get breadcrumbs () {
    if (!this.course) {
      return [{ name: 'База знаний', path: { name: 'master.depository' } }]
    } else {
      return [
        { name: 'База знаний', path: { name: 'master.depository' } },
        { name: this.course.title, path: { name: 'master.depository.item', params: { courseID: this.courseID.toString() } } },
        { name: 'Учебные файлы', path: { name: 'master.depository.item.files', params: { courseID: this.courseID.toString() } } },
      ]
    }
  }

  private get isEmpty() {
    return !this.folders.length
  }

  private mounted () {
    if (!this.course || this.course.id !== this.courseID) {
      MasterDepositoryModule.fetchCourses()
        .catch(this.notifyError)
    }

    MasterDepositoryModule.fetchTrainingFilesTree({ courseID: this.courseID, courseFolderID: this.monthID })
      .catch(this.notifyError)

    if (!MasterDepositoryModule.trainingFilesMonth.courseID || this.courseID !== MasterDepositoryModule.trainingFilesMonth.courseID) {
      MasterDepositoryModule.fetchTrainingFilesMonth({ courseID: this.courseID })
        .catch(err => {
          if (err && err.response && err.response.status === 403) {
            this.$router.replace({ name: 'master.depository' })
              .catch(() => {return})
          }
          this.notifyError(err)
        })
    }
  }

  private handleFolderClick(folderID: number) {
    this.$router.replace({
      name: 'master.depository.item.files.month.folder',
      params: {
        courseID: String(this.courseID),
        folderID: String(folderID),
        monthID: String(this.monthID),
      },
      replace: true,
    })
  }

  private handleDownload(folderID: number) {
    MasterDepositoryModule.downloadTrainingFilesFolder({
      courseID: this.courseID,
      courseFolderId: this.monthID,
      mediaFolderId: folderID,
    })
      .then(() => {
        this.notifySuccess('Формируем архив с файлами. Когда он будет готов для скачивания – придет уведомление')
      })
      .catch(this.notifyError)
  }

  private changeView(value: IMasterDepositoryView) {
    MasterDepositoryModule.setDepositoryView(value)
  }

  private metaInfo (): MetaInfo {
    return {
      title: 'Учебные файлы',
    }
  }
}
